var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:['switch', { small: _vm.small, disabled: _vm.disabled }]},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event.target.checked)}}}),_c('span',{staticClass:"slider"})])
}
var staticRenderFns = []

export { render, staticRenderFns }